import { CommonService } from '../../services';

export const getDefaultData = (userData) => ({
  Country: userData.country,
  'Email Address': userData.email,
  'First Name': userData.given_name,
  'Last Name': userData.family_name,
  City: userData.address.locality,
  Telephone: userData.phone_number,
  'Member ID': userData.nar_membership_id,
  'State/Province': userData.address.region,
  'Postal Code': userData.address.postalCode,
  'Street Address': userData.address.streetAddress,
});

const getUserValue = (question, data) => {
  switch (question) {
    case 'Country':
      return data.country;
    case 'Email Address':
      return data.email;
    case 'First Name':
      return data.given_name;
    case 'Last Name':
      return data.family_name;
    case 'City':
      return data.address.locality;
    case 'Telephone':
      return data.phone_number;
    case 'Member ID':
      return data.nar_membership_id;
    case 'State/Province':
      return data.address.region;
    case 'Postal Code':
      return data.address.postalCode;
    case 'Street Address':
      return data.address.streetAddress;
  }
};

const BASIC_DATA = {
  City: true,
  Country: true,
  'Member ID': true,
  'Last Name': true,
  Telephone: true,
  'First Name': true,
  'Postal Code': true,
  'Email Address': true,
  'Street Address': true,
  'State/Province': true,
};

export const getUserData = (questions, setAnswers, userData) => {
  const responses = {};
  questions.forEach((el) => {
    const value = getUserValue(el.QuestionDescription, userData);
    if (value) {
      responses[el.ID] = {
        QuestionID: el.ID,
        UserFirstName: userData.given_name,
        UserLastName: userData.family_name,
        QuestionDescription: el.QuestionDescription,
        Value: String(value),
      };
    }
  });
  setAnswers((prev) => ({ ...prev, ...responses }));
};

export const validateResponses = (data, questions, setRequired, func) => {
  setRequired({});

  const required = questions.reduce((prev, current) => {
    if (current.Required) {
      if (!data[current.ID]) return { ...prev, [current.ID]: true };
    }
    return prev;
  }, {});

  if (!Object.keys(required).length) {
    return func();
  } else {
    setRequired(required);
  }
};

const getUser = (data) => {
  const response = {};

  Object.values(data).forEach((el) => {
    if (el.QuestionID == 9) response.FirstName = el.Value;
    if (el.QuestionID == 10) response.LastName = el.Value;
    if (el.QuestionID == 11) response.NrdsID = el.Value;
    if (el.QuestionID == 21) response.Email = el.Value;
  });

  return response;
};

export const submitMentorForm = async (
  answers,
  setSaving,
  setSuccess,
  isReview
) => {
  setSaving(true);
  try {
    const user = { ...getUser(answers) };
    const {
      message,
      response: { ID },
    } = await CommonService.saveUser(
      {
        ...user,
      },
      'Mentors'
    );
    if (message === 'User already exists' && !isReview) {
      console.error('Member already submitted form');
      return;
    }
    const responses = Object.values(answers).map((el) => {
      return {
        UserID: String(ID),
        UserLastName: user.LastName,
        UserFirstName: user.FirstName,
        ...el,
      };
    });
    await CommonService.saveResponses(responses, 'MentorResponses');
    setSuccess(true);
  } catch (e) {
    console.error(e);
  } finally {
    setSaving(false);
  }
};
